enum UserRightScopeEnum {
    All = 'All',
    Group = 'Group',
    Own = 'Own',
    NoRights = 'NoRights'
};

export default UserRightScopeEnum;